
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface PractitionerAboutProps {
  bio?: string;
}

const PractitionerAbout: React.FC<PractitionerAboutProps> = ({ bio }) => {
  const { t } = useTranslation('practitioners');

  if (!bio) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('about')}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-earth-700 leading-relaxed">{bio}</p>
      </CardContent>
    </Card>
  );
};

export default PractitionerAbout;
